import { z } from 'zod';
export const assignRoleToMembershipBodySchema = z.object({
    roleId: z.string().uuid(),
});
//# sourceMappingURL=assign-role-to-membership.schema.js.map